export const buildVersion = {
  version: '1.4',
  buildNumber: 21,
  commit: '19a0ab52b',
};
